import { all, call, put, takeLatest } from 'redux-saga/effects';
import API from '../../helpers/sagaApi/sagaApi';
import Actions, { SagaBlogTypes } from './sagaBlogRedux';
import AppConfig from '../../configs/AppConfig';

export function* requestGetHisobusBlogPage(action) {
    const tag = '[REQUEST_GET_HISOBUS_BLOG_PAGE]';
    try {
        // step 1: perform input validation
        const inputValid = true; // IDE-Help, do not delete me
        if (inputValid) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetHisobusBlogPage);
            if (response.status === 200 && response.data.statusCode === 200) {
                if (AppConfig.isDevelopment) { console.log(`${tag} requestGetHisobusBlogPage response :`, response.data); }
                yield put(Actions.getHisobusBlogPageSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me 
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetHisobusBlogPage failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getHisobusBlogPageFailure(message));
    }
}

export function* requestGetHisobusBlogDetailPage(action) {
    const tag = '[REQUEST_GET_HISOBUS_BLOG_DETAIL_PAGE]';
    try {
        // step 1: perform input validation
        const inputValid = true; // IDE-Help, do not delete me
        if (inputValid) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetHisobusBlogDetailPage, action.id);
            if (response.status === 200 && response.data.statusCode === 200) {
                if (AppConfig.isDevelopment) { console.log(`${tag} requestGetHisobusBlogDetailPage response :`, response.data); }
                yield put(Actions.getHisobusBlogDetailPageSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetHisobusBlogDetailPage failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getHisobusBlogDetailPageFailure(message));
    }
}

export default function* rootSaga() {
    yield all([
        takeLatest(SagaBlogTypes.REQUEST_GET_HISOBUS_BLOG_PAGE, requestGetHisobusBlogPage),
        takeLatest(SagaBlogTypes.REQUEST_GET_HISOBUS_BLOG_DETAIL_PAGE, requestGetHisobusBlogDetailPage),
    ]);
}


// WEBPACK FOOTER //
// ./src/redux/sagaBlog/sagaBlogSaga.ts